import { Component, OnInit } from '@angular/core';
import {BlockService} from '../../service/BlockService';
import {EmitterService} from '../../service/EmitterService';

@Component({
  selector: 'app-details-blocks',
  templateUrl: './details-blocks.component.html',
  styleUrls: ['./details-blocks.component.css']
})
export class DetailsBlocksComponent implements OnInit {
  data = [];
  show  = false;
  constructor(private emit: EmitterService) {
  }

  ngOnInit() {
    this.emit.getDetailsEventEmitter().subscribe((item) => {
      const data = item.optionData.temps_data;
      // console.log(Object.keys(data))
      const  el  = document.querySelector('app-details-blocks')
      const  pt  = el.parentElement
      this.data = data
      if (pt.classList.contains('show')) {
        pt.classList.remove('show')
      } else {
        pt.classList.add('show')
      }
    })
  }
  getHead(head) {
    return Object.keys(head)
  }

  getBody(head) {
    return Object.values(head)
  }
}



// WEBPACK FOOTER //
// ./src/app/view/details-blocks/details-blocks.component.ts